import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useCreateOperationMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { parseCreateOperationParams } from 'api/helpers/operation';
import { useNotifyMessages } from 'api/helpers/useNotifyMessages';
import { CreateAndUpdateOperationParams } from 'api/types/params';

export const useCreateOperation = () => {
  const notifyMessage = useNotifyMessages();

  const [createOperation, { loading, error: apolloError }] =
    useCreateOperationMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    createOperation: useCallback(
      async (data: CreateAndUpdateOperationParams) => {
        const input = parseCreateOperationParams(data);
        const res = await createOperation({ variables: { input } });

        if (res.data?.createOperation?.messages) {
          notifyMessage(res.data.createOperation.messages);
        }

        return res.data?.createOperation?.data.operationId;
      },
      [createOperation, notifyMessage]
    ),
  };
};
